import React from 'react'
import { COLORS } from '../pages/theme';

const ExternalFilterClear=({
    filters={},
    staticKeys=[],
    onClear
})=> {
    let newStaticKeys=staticKeys.concat(['per_page','page','query'])
    let o=JSON.parse(JSON.stringify(filters))
    let new_filters={};
    newStaticKeys.forEach(k=>{
        new_filters[k]=filters[k]
    })
    newStaticKeys.forEach(k=>delete o[k]);
    console.log("remaining filter",o)
    if(Object.keys(o).length>0){
        return (
            <div style={{
                paddingLeft:8,
                paddingRight:8,
                display:'flex',
                flexDirection:'row',
                alignItems:'baseline',
                color:COLORS.danger_primary
            }}>
                The results are externally filtered. &nbsp;&nbsp;&nbsp;
                <a onClick={()=>{
                    typeof onClear==='function'&&onClear(new_filters)
                }}>Clear External Filters</a>
            </div>
        )
    }else{
        return null
    }
    
}

export default ExternalFilterClear
